export default __webpack_public_path__ + "static/media/HeaderBG.8b7e683a.png";